{
  "agb-form": {
    "text": {
      "accept": "J'accepte les ",
      "agb": "Conditions générales de vente"
    }
  }
}
